import { CommitmentSourcesSimulateService_commitmentSourcesSimulateServicePostEntity } from '@festina/life-general-types/life/hooks/CommitmentSourcesSimulateService_commitmentSourcesSimulateServicePostEntity'

export const useLazyFetchCommitmentVersionSimulation =
  CommitmentSourcesSimulateService_commitmentSourcesSimulateServicePostEntity.useLazyQuery
